import { Box } from "@mui/system";
import React, { useState, useEffect, useContext } from "react";
import { getGraphStyle } from "../../components/customstyles/GraphStyle";
import { Typography, useTheme, Card } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import GridContainer from "../../components/grid/GridContainer.jsx";
import GridItem from "../../components/grid/GridItem.jsx";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { AuthContext } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";

const useStyles = () => {
  let theme = useTheme();
  return getGraphStyle(theme);
};

function AssessmentGraph(props) {
  const [data, setGraphData] = useState([]);
  const [assessmentGraphData, setAssessmentGraphData] = useState([]);
  const { makeAuthenticatedApiCall } = useContext(AuthContext);
  const location = useLocation();

  const styles = useStyles();
  const [slelctedValue, setSlelctedValue] = React.useState("all");

  function addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }
  const [minDateForXAxis, setMinDateForXAxis] = useState(
    addMonths(new Date(), -24).getTime()
  );
  const [tickInterval, setTickInterval] = React.useState(
    2 * 30 * 24 * 3600 * 1000
  );

  const options = {
    title: { text: "" },
    time: {
      useUTC: false,
    },
    credits: { enabled: false }, //hide highchart.com
    legend: { enabled: false },
    yAxis: {
      title: { text: "Total Score" }, //Add the label
      min: 0,
      max: 30,
      tickInterval: 5,
      gridLineWidth: 1,
    },
    xAxis: {
      type: "datetime",
      labels: {
        formatter: function () {
          return (
            "<div>" +
            [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ][new Date(this.value).getMonth()] +
            "<br />" +
            new Date(this.value).getFullYear() +
            "</div>"
          );
        },
      },
      max: addMonths(new Date(), 1).getTime(),
      min: minDateForXAxis,
      tickInterval: tickInterval,
    },
    series: [
      {
        marker: {
          enabled: true,
        },
        stickyTracking: false,
        data,
      },
    ],
    tooltip: {
      backgroundColor: "#fff",
      "AIMS Score": 1,
      style: {
        pointerEvents: "auto",
      },
      stickOnContact: true,
      shared: true,
      useHTML: true,
      formatter: function () {
        return (
          '<div style="padding:5px 2px 5px 2px; width:100% ">' +
          '<span style="font-size:12px;font-weight:400;line-height:13.62px;color:#546E7A;">' +
          [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ][new Date(this.x).getDay()] +
          ", " +
          new Date(this.x).getDate() +
          " " +
          [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ][new Date(this.x).getMonth()] +
          " " +
          new Date(this.x).toLocaleString("en-US", {
            hour: "numeric",
            minute: "numeric",
            hour12: true,
          }) +
          "</span>" +
          "<br/>" +
          '<li><span style="font-size:12px;font-weight:400;line-height:13.62px;color:#546E7A;">AIMS Score: ' +
          this.y +
          "</span></li>" +
          '<li><span style="font-size:12px;font-weight:400;line-height:13.62px;color:#546E7A;">Conducted By: ' +
          this.point.updatedBy +
          "</span></li>" +
          `<span style="margin-left:15px; cursor: pointer;"><a href=/patients/${
            location.pathname.substring(1).split("/")[1]
          }/assessment/result/${
            this.point.assessmentId
          }>Go to Results</a></span> </span>` +
          "</div>"
        );
      },
    },
  };

  const getLatestDatetimeForEachUniqueDate = (graphDatesArray) => {
    const latestPerDay = [];
    let completedAssessments = graphDatesArray.filter((e) => e.status === 4);
    const groupedByDate = completedAssessments.reduce((acc, curr) => {
      completedAssessments = new Date(curr.assessmentDate)
        .toISOString()
        .split("T")[0];
      if (!acc[completedAssessments]) {
        acc[completedAssessments] = [];
      }
      acc[completedAssessments].push(curr);
      return acc;
    }, {});
    for (const date in groupedByDate) {
      const entries = groupedByDate[date];
      const latestEntry = entries.reduce((latest, current) => {
        return current.assessmentDate > latest.assessmentDate
          ? current
          : latest;
      });

      latestPerDay.push(latestEntry);
    }
    latestPerDay.sort(
      (a, b) =>
        new Date(a.assessmentDate).getTime() -
        new Date(b.assessmentDate).getTime()
    );
    return latestPerDay;
  };
  const getDataBasedOnSelection = (month, gData) => {
    const startDate = new Date().getTime();
    let endDate = addMonths(new Date(), month).getTime();
    setMinDateForXAxis(endDate);
    let graphData = [];
    gData &&
      gData.map((item) => {
        if (
          new Date(item.assessmentDate).getTime() >= endDate &&
          new Date(item.assessmentDate).getTime() <= startDate
        ) {
          graphData.push({
            x: new Date(item.assessmentDate).getTime(),
            y: item.score,
            updatedBy: item.updatedBy,
            assessmentId: item.assessmentId,
          });
        }
      });
    setGraphData(graphData);
  };
  const handleToggleButtonChange = (event, selectedValue) => {
    if (selectedValue !== null) {
      setSlelctedValue(selectedValue);
    }
    if (selectedValue === "all") {
      setTickInterval(2 * 30 * 24 * 3600 * 1000);
      getDataBasedOnSelection(-24, assessmentGraphData);
    } else if (selectedValue === "6m") {
      setTickInterval(30 * 24 * 3600 * 1000);
      getDataBasedOnSelection(-6, assessmentGraphData);
    } else if (selectedValue === "1y") {
      setTickInterval(30 * 24 * 3600 * 1000);
      getDataBasedOnSelection(-12, assessmentGraphData);
    }
  };

  useEffect(() => {
    const fetchAss = async () => {
      let patientId;
      let pathname = location.pathname.substring(1);
      patientId = pathname.split("/")[1];
      let response = await makeAuthenticatedApiCall(
        "get",
        `/api/userservice/getPatientAssessments/${patientId}`,
        {}
      );
      if (response.data) {
        let filterData = getLatestDatetimeForEachUniqueDate(response.data);
        getDataBasedOnSelection(-24, filterData);
        setAssessmentGraphData(filterData);
      }
    };
    if (props.assessmentGraphData) {
      let removeDuplicateData = getLatestDatetimeForEachUniqueDate(
        props.assessmentGraphData
      );
      setAssessmentGraphData(removeDuplicateData);
      getDataBasedOnSelection(-24, removeDuplicateData);
    } else {
      fetchAss();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = 1;
  return (
    <Box sx={styles.loadingCoverageStyle}>
      <GridContainer sx={{ marginBottom: "5px", marginTop: "10px" }}>
        <GridItem lg={6} md={6} sm={6} xs={6} sx={styles.resultTrendStyle}>
          Results Trend
        </GridItem>
        <GridItem
          lg={6}
          md={6}
          sm={6}
          xs={6}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ToggleButtonGroup
            color="primary"
            value={slelctedValue}
            exclusive
            onChange={handleToggleButtonChange}
            // aria-label="Platform"
            sx={{
              height: "35px",
              "& .Mui-selected": {
                background: "#0D47A1 !important",
                color: "#fff !important",
              },
              "& .Mui-selected .MuiToggleButton-label span": {
                color: "#fff !important",
              },
            }}
            aria-label="text alignment"
          >
            <ToggleButton value="6m">
              <Typography sx={styles.toggleButtonText}>6M</Typography>
            </ToggleButton>
            <ToggleButton value="1y">
              <Typography sx={styles.toggleButtonText}>1Y</Typography>
            </ToggleButton>
            <ToggleButton value="all">
              <Typography sx={styles.toggleButtonText}>All</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </GridItem>
      </GridContainer>

      {data.length > 0 && (
        <Card
          sx={{
            padding: "20px 15px 25px 20px",
            marginBottom: "30px",
            marginTop: "15px",
          }}
        >
          <HighchartsReact
            key={value}
            highcharts={Highcharts}
            options={options}
          />
        </Card>
      )}
    </Box>
  );
}

export default AssessmentGraph;
